<template>
  <v-container class="mx-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card
          flat
          :class="cardClasses"
          v-if="Object.keys(gate).length != 0"
        >
          <v-tabs v-model="activeTab" class="selected-tab-custom">
            <template v-for="tab in filterTabs()">
              <template v-if="tab.show && isDisplayInfoGate">
                <v-tab :key="tab.name" class="custom-tab" :disabled="tab.isDisabled">
                  {{ tab.name }}
                </v-tab>
                <v-tab-item :key="tab.name" class="tab-item" :class="{'color-change' : hasFlatCard }">
                  <component v-bind:is="tab.component" v-bind="tab.props"/>
                </v-tab-item>
              </template>
            </template>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GeneralInfo from './components/GeneralInfo.vue';
import Keys from '@/components/gate/DetailGate/components/Keys';

export default {
  name: 'DetailGate',
  props: ['id'],
  data () {
    return {
      disableRoleName: true,
      isDisplayInfoGate: true,
      activeTab: 0,
      hasFlatCard: true,
    };
  },
  async created () {
    this.isDisplayInfoGate = false;
    this.getData();
  },
  watch: {
    activeTab: {
      handler: function (after, before) {
        this.updateFlatCard();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      gate: 'Gate/gate',
    }),
    tabs () {
      return [
        {
          name: 'Информация',
          component: GeneralInfo,
          route: 'DetailGateNewGeneralInfo',
          props: {
            getData: this.getData,
          },
          show: this.disableRoleName,
        },
        {
          name: 'Ключи',
          component: Keys,
          route: 'DetailGateKeys',
          props: {
            getData: this.getData,
          },
          show: this.disableRoleName,
        },
      ];
    },
    cardClasses () {
      return {
        'pb-5': true,
        'border-card': true,
        'color-change': this.hasFlatCard,
      };
    },
  },
  methods: {
    ...mapActions({
      getWebInfoGate: 'Gate/getWebInfoGate',
      getResidentialComplex: 'ResidentComplex/getComplex',
    }),
    getData () {
      this.getWebInfoGate({
        id: this.id,
      })
        .then(() => {
          this.isDisplayInfoGate = true;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    updateFlatCard () {
      this.hasFlatCard = this.activeTab === 0;
    },
    filterTabs () {
      return this.tabs.filter(tab => {
        return this.$canRoute(tab.route);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tab {
  border: 1px solid #C5C9CF;
  border-radius: 16px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.v-tab {
  background-color: #E7E3E3;
}
v-tab:before {
  background-color: #E7E3E3;
  color: black;
}
.v-tab.v-tab--active {
  background-color: white;
  color: black;
}
.color-change {
  background-color: #F5F5F5;
}
.v-tab--active.v-tab:not(:focus) {
  border-radius: 16px;
}
.v-tab--active.v-tab:not(:focus)::before {
  border-radius: 16px;
}
.border-card {
  border-radius: 16px;
}
</style>
